export default "__VITE_ASSET__D72zqJY7__"